import React from 'react';
import { Button, KnowMorePopin, SubmitButton } from 'Components';
import { Link } from 'react-router-dom';
import { Action, BOTTOM, TrackingService } from 'Services';
import { FRStep } from '@forgerock/javascript-sdk';
import { Origin } from 'Constants';

export const handleClick =
  (preventDefault: boolean, stage: Stage, action: Action, origin: Origin, mobile = false) =>
  (event: React.MouseEvent<HTMLElement>) => {
    const eventId = TrackingService.buildEventIdClick(stage, action, origin);
    const path = TrackingService.buildPath(stage, mobile, origin);
    TrackingService.triggerTrackingClic(eventId, path, event);

    if (preventDefault) {
      event.preventDefault();
    }
  };

const connectMeButton = (
  <Link to=".." className="w-full">
    Me connecter
  </Link>
);

export const mapStageToExtraComponents = (step: FRStep, origin: Origin, mobile = false, withErrorPage = false) => {
  const stage = step?.getStage() as Stage;
  const extraComponents = [];
  let buttonContent: string | JSX.Element = 'Continuer';
  let preventDefault = false;

  if (withErrorPage) {
    return [
      <Button key="submit-button" variant="brand" onClick={handleClick(false, stage, 'link', origin)}>
        <Link to="/">Revenir à la page de connexion</Link>
      </Button>,
    ];
  }

  const goBackCheckEmail = () => (
    <div key="forget-password" className="flex flex-col items-center">
      <span>Vous ne l’avez pas reçu ?</span>
      <Link key="login" to=".." className="text-navy-blue hover:underline" onClick={handleClick(preventDefault, stage, 'link', origin)}>
        Vérifiez votre adresse e-mail
      </Link>
    </div>
  );

  switch (stage) {
    case 'Connexion Page':
      buttonContent = 'Me connecter';
      extraComponents.push(
        <Link
          key="forget-password"
          to="../reset-password"
          className="text-navy-blue hover:underline"
          onClick={handleClick(preventDefault, stage, 'link', origin)}
        >
          Mot de passe oublié ?
        </Link>,
      );
      break;

    case 'Reset Password Page':
      buttonContent = 'Envoyer l’e-mail';
      extraComponents.push(
        <span key="reset-password-link">
          Vous vous en souvenez ?{' '}
          <Link
            key="login"
            to="../login"
            className="text-navy-blue hover:underline"
            onClick={handleClick(preventDefault, stage, 'link', origin)}
          >
            Connexion
          </Link>
        </span>,
      );
      break;

    case 'Email sent OK':
      buttonContent = connectMeButton;
      extraComponents.push(goBackCheckEmail());
      break;

    case 'Password update OK':
      buttonContent = connectMeButton;
      preventDefault = true;
      break;

    case 'Registration Page':
      buttonContent = 'Créer mon compte';
      extraComponents.push(<KnowMorePopin key="know-more-popin" />);
      break;

    case 'OTP Page':
      buttonContent = 'Me connecter';
      extraComponents.push(goBackCheckEmail());
      break;

    case 'Retry or resend OTP':
      buttonContent = 'Réessayer';
      extraComponents.push(
        <div key={'login' + BOTTOM} className="flex flex-col items-center">
          <span>Si vous n’avez pas reçu d’e-mail :</span>
          <Link to=".." className="underline" onClick={handleClick(false, stage, 'link', origin)}>
            Vérifiez l’adresse e-mail
          </Link>
        </div>,
      );
      break;

    case 'Locked User Page':
      buttonContent = (
        <Link to="../reset-password" onClick={handleClick(false, stage, 'link', origin)}>
          Réinitialiser mon mot de passe
        </Link>
      );
  }

  extraComponents.push(
    <SubmitButton
      id="submit-button"
      key="submit-button"
      variant="brand"
      preventDefault={preventDefault}
      mobile={mobile}
      origin={origin}
      stage={stage}
    >
      {buttonContent}
    </SubmitButton>,
  );

  return extraComponents;
};
